import { render } from "./App.vue?vue&type=template&id=b68f2bc4"
const script = {}
script.render = render

export default script